// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 42" enableBackground="new 0 0 38 42" xmlSpace="preserve">
<g>
	<rect x="8.58" y="18.83" width="10.42" height="10.42"/>
	<path d="M33.58,4.25H31.5V0.08h-4.17v4.17H10.67V0.08H6.5v4.17H4.42c-2.31,0-4.15,1.88-4.15,4.17L0.25,37.58
		c0,2.29,1.85,4.17,4.17,4.17h29.17c2.29,0,4.17-1.88,4.17-4.17V8.42C37.75,6.12,35.88,4.25,33.58,4.25z M33.58,37.58H4.42V14.67
		h29.17V37.58z"/>
</g>
</svg>;
};

export default React.memo(Calendar);
